import {Context} from '@/project'

/**
 * Refreshing router hash number
 */
let number: number = 0

/**
 * Max count refreshing hash number
 */
const MAX_REFRESH_NUMBER = 100

/**
 * Get refreshing router hash number
 * @example /foo/#[hash number]
 */
const getRefreshNumber = (): number => {
  number += 1
  /* istanbul ignore if No way to test*/
  if(number > MAX_REFRESH_NUMBER) {
    number = 0
  }
  return number
}

/**
 * Reset refreshing router hash number
 */
export const resetRefreshNumber = (): void => {
  number = 0
}

declare module 'vue/types/vue' {
  /**
   * Define VNode $refreshPage
   */
  interface Vue {
    $refreshPage: (name?: string, hard?: boolean) => void
  }
}

/**
 * Register refresh router
 * It makes vue-router run hooks such as 'router.beforeEach' with same path (refresh)
 * @export default
 */
export default function refreshRouterBoot({Vue, router}: Context) {
  if(!router) {
    throw new Error('[boot/refresh-router] needs vue-route')
  }
  if(router.mode !== 'history') {
    throw new Error('[boot/refresh-router] is working for only vue router history mode')
  }

  Vue.prototype.$refreshPage = function (name?: string, hard: boolean = false) {
    const router = this.$router
    const _name = name || String(getRefreshNumber())
    const {currentRoute} = router
    const to: any = {
      path: currentRoute.path,
      query: currentRoute.query,
    }
    if(hard) {
      to.force = true
      return router.go(to)
    }
    try {
      to.hash = _name
      return router.replace(to)
    } catch(e) {
      /* istanbul ignore next the logic will not pass catch*/
      if(e.name === 'NavigationDuplicated') {
        return
      }
      /* istanbul ignore next the logic will not pass catch*/
      throw e
    }
  }
}
